import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import UsuariosAll from './components/UsuariosAll';

export default function Usuario() {
    return (
      <>
        <MainContent titulo='Relación Usuarios' component={ <UsuariosAll /> } />        
        
        <Outlet />
      </>
    );      
}